const SAVED_CARD_DISCLOSURE =
    "I agree to save this card securely for future payments and card holds that I approve.";
const SHARED_HOLD_DISCLOSURE =
    "While it is active, this hold may also meet this business's card hold requirements for other activities.";

const composeSavedCardDisclosure = (additionalWording) => {
    const additional = additionalWording?.trim();
    return additional ? `${SAVED_CARD_DISCLOSURE} ${additional}` : SAVED_CARD_DISCLOSURE;
};

const normaliseHoldCaptureTerms = (terms) => (terms || "")
    .trim()
    .replace(/^if\b[\s,:-]*/i, "")
    .replace(/[.\s]+$/, "");

const formatMoney = (currency, amount) => {
    const numericAmount = Number(amount);
    if (!Number.isFinite(numericAmount) || numericAmount <= 0) return null;
    return `${(currency || "AUD").trim().toUpperCase()} ${(numericAmount / 100).toFixed(2)}`;
};

const getFinancialActionAgreement = (props) => {
    if (!props || props.mode === "card-capture") return null;

    const currency = (props.currency || "AUD").trim().toUpperCase();
    const amount = props.customerEntersAmount
        ? (() => {
            const minimum = formatMoney(currency, props.minimumAmount);
            const maximum = formatMoney(currency, props.maximumAmount);
            return minimum && maximum
                ? `the amount I enter above (between ${minimum} and ${maximum})`
                : null;
        })()
        : formatMoney(currency, props.fixedAmount);
    if (!amount) return null;

    if (props.mode === "take-payment") {
        return `I authorise this business to take ${amount} as a payment now.`;
    }
    if (props.mode !== "security-hold") return null;

    const duration = Number(props.holdDurationHours);
    if (!Number.isFinite(duration) || duration <= 0) return null;
    const durationText = `${duration} ${duration === 1 ? "hour" : "hours"}`;
    const holdDisclosure = props.customerEntersAmount
        ? `I authorise this business to place a card hold for ${amount} for up to ${durationText}. This reserves funds but does not take a payment now.`
        : `I authorise this business to place a card hold of ${amount} for up to ${durationText}. This reserves funds but does not take a payment now.`;
    return `${holdDisclosure} ${SHARED_HOLD_DISCLOSURE}`;
};

const getHoldCaptureAgreement = (props) => {
    if (props?.mode !== "security-hold" || !props.allowHoldCapture) return null;

    const terms = normaliseHoldCaptureTerms(props.holdCaptureTerms);
    const duration = Number(props.holdDurationHours);
    if (!terms || !Number.isFinite(duration) || duration <= 0) return null;
    const durationText = `${duration} ${duration === 1 ? "hour" : "hours"}`;

    const currency = (props.currency || "AUD").trim().toUpperCase();
    const fixedAmount = Number(props.fixedAmount);
    const amount = props.customerEntersAmount
        ? "up to the held amount I choose above"
        : Number.isFinite(fixedAmount) && fixedAmount > 0
            ? `up to ${currency} ${(fixedAmount / 100).toFixed(2)} from the card hold`
            : "up to the held amount";

    return `I authorise this business to take ${amount} as a payment while it is active for up to ${durationText} if ${terms}.`;
};

const getPaymentAgreement = (props, guestPayment = false) => [
    getFinancialActionAgreement(props),
    guestPayment ? props?.consentText?.trim() : composeSavedCardDisclosure(props?.consentText),
    getHoldCaptureAgreement(props)
].filter(Boolean).join(" ");

module.exports = {
    SAVED_CARD_DISCLOSURE,
    SHARED_HOLD_DISCLOSURE,
    composeSavedCardDisclosure,
    normaliseHoldCaptureTerms,
    getFinancialActionAgreement,
    getHoldCaptureAgreement,
    getPaymentAgreement
};
